import * as React from 'react'

import { cn } from '@/lib/utils'

interface LabelProps extends React.ComponentProps<'label'> {
    /** Hiện dấu `*` đỏ ở cuối nhãn cho field bắt buộc. Dùng prop này thay vì tự
     *  chèn <span> — để dấu bắt buộc đồng nhất toàn app (đỏ, đúng vị trí). */
    required?: boolean
}

function Label({ className, required, children, ...props }: LabelProps) {
    return (
        <label
            data-slot="label"
            className={cn(
                'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
                className,
            )}
            {...props}
        >
            {children}
            {required && (
                <span aria-hidden="true" className="text-destructive ml-0.5">
                    *
                </span>
            )}
        </label>
    )
}

export { Label }
